import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { theme, toRem, StyledIncrementDiv } from '@marriott/mi-ui-library-shop';
import { StyledRowDiv } from '../../atoms/roomsAndGuestsRow/index.styles';
import { StyledPopupDiv } from '../../atoms/popup/popup.styles';
import { StyledPopupHeaderDiv } from '../../atoms/popupHeader/popupHeader.styles';
import { StyledPopupMain } from '../../atoms/popupMain/popupMain.styles';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledRoomsAndGuestDiv = styled.div`
  ${rtl`
  position: relative;
  font-family: ${theme.fontFamily.swiss};
  font-weight: ${theme.fonts['fontWeightMedium']};
  .child-slider-container {
    text-align: center;
    span.MuiSlider-root {
      margin: 0 auto;
      span.MuiSlider-rail {
        background-color: ${theme.color['base-10']};
        height:${toRem(1)} !important;
      }
      span.MuiSlider-track {
        height:${toRem(3)} !important;
      }
      span.MuiSlider-mark {
        height:${toRem(1)} !important;
      }
      span.MuiSlider-markLabel[data-index='0'] {
        top: ${toRem(5)};
        color: ${theme.color['dark-gray-13']};
      }
      span.MuiSlider-markLabel {
        font-size:${toRem(12)};
      }
      span.MuiSlider-markLabel[data-index='1'] {
        top: ${toRem(5)};
        color: ${theme.color['dark-gray-13']};
      }
    }
  }
  .search-child-label {
    font-size: ${toRem(12)};
    &.t-label-xs {
      text-transform: uppercase;
      color: ${theme.color['dark-gray-13']} !important;
    }
  }
  &.search-child-rooms-form {
    ${StyledIncrementDiv} {
      button {
        @media ${theme.mediaQuery.mobileOnly} {
          padding: 0;
        }
        span {
          &.icon-minus,
          &.icon-plus {
           margin-top: -${toRem(1.8)} !important;
            font-weight: 500;
            margin-left:-${toRem(0.6)} !important;
            width:${toRem(32)} !important;
            height:${toRem(32)} !important;
          }
        }
      }
    }
  }

  &.adf-search-rooms{
    min-height: ${toRem(80)} !important;
    @media ${baseVariables.mediaQuery.lg} {
      min-height:${toRem(60)} !important;
    }
  }
  &.search-rooms {
    min-width: ${toRem(220)};
    min-height: ${toRem(68)};
    @media ${theme.mediaQuery.allTablets} {
      min-width: 26%;
      min-height: ${toRem(73)};
      padding-left: ${toRem(24)};
      padding-top: ${toRem(10)};
    }
    ${StyledRowDiv} {
      border-bottom-color: ${theme.color['light-gray-6']};
    }
    .rg-popup {
      width: ${toRem(364)} !important;
      max-height: ${toRem(450)};
    }
    .open-state {
      z-index:4 !important;
    }
    .close-popup-header {
      background: transparent;
      box-shadow: none;
      padding: 0 0 0 ${toRem(40)};
      z-index: 1;
      @media ${theme.mediaQuery.allTablets} {
        padding-left: ${toRem(24)};
        padding-top: ${toRem(0)};
      }
    }
    ${StyledPopupMain} {
      @media ${theme.mediaQuery.allTablets} {
        padding-bottom: 0;
      }
    }
    ${StyledPopupDiv} {
      padding-top: 0;
      @media ${theme.mediaQuery.allTablets} {
        padding: 0 ${toRem(24)} ${toRem(24)};
        left: 0;
      }
    }
    margin-right: ${toRem(24)};
    padding: 0;
    span {
      &.icon-minus,
      &.icon-plus {
        margin-top: -${toRem(1.8)} !important;
        font-weight: 500;
        margin-left:-${toRem(0.28)} !important;
        width:${toRem(32)} !important;
        height:${toRem(32)} !important;
      }
    }
    ${StyledPopupHeaderDiv} {
      padding-top: ${toRem(10)};
      span.t-label-xs {
        font-size: ${toRem(12)};
        font-weight: ${theme.fonts['fontWeightMedium']};
        letter-spacing: 0.08125rem;
        text-transform: uppercase;
      }
    }

    .adf-rooms-popup {
      width: ${toRem(375)} !important;
      @media ${baseVariables.mediaQuery.lg} {
      margin-top:${toRem(-10)};
        }
      ${StyledPopupHeaderDiv} {
        padding-top: ${toRem(10)};
       
    }
  }
    button {
      background: none;
      padding: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &:not(.btn-disable) {
        border-color: ${theme.color['mine-shaft']};
      }
      .icon-dropdown-down {
        font-size: ${toRem(20)};
        position: absolute;
        line-height: 1;
        padding-left: ${toRem(6)};
      }
    }
  }
  .search-button {
    color: ${theme.color['cod-grey']};
    font-size: ${toRem(16)};
    line-height: ${toRem(22)};
    font-weight: ${theme.fonts['fontWeightMedium']};
    &:focus-visible {
    outline: ${toRem(1)} solid ${theme.color['black']};
    }
  }
  .adf-btn {
    @media ${theme.mediaQuery.minDesktop} {
      font-size: ${toRem(22)};
      line-height: ${toRem(26)};
    }
    
  }

  @media ${theme.mediaQuery.mobileOnly} {
    height: calc(100% - 132px);
    overflow-y: auto;
  }
  .rg-main {
    @media ${theme.mediaQuery.tablet} {
      padding-bottom: ${toRem(24)};
    }
  }
  ${StyledRowDiv} {
    height: ${toRem(72)};
  }
  .reset-button-container {
    text-align: right;
    margin-top: ${toRem(10)};
    button {
      font-size: ${toRem(12)};
      color: ${theme.color['dark-gray-1']};
    }
  }
  .children-age-row {
    margin: 0 ${toRem(24)} ${toRem(32)} ${toRem(16)};
    color: ${theme.color['gray']};
    font-family: ${theme.fontFamily.swiss};
    font-weight: ${theme.fonts['fontWeightMedium']};
    @media ${theme.mediaQuery.tablet} {
      height: ${toRem(77)};
      margin: 0 0 ${toRem(16)};
      &:last-child {
        margin-bottom: 0;
      }
    }
    &.search-rooms-row {
      .child-age-input{
        position:relative;
         input{
          @media ${theme.mediaQuery.mobileOnly} {
            position:relative;
            z-index:2;
            border-radius: 0;


          }
        }
        .child-age-input-val{
          position:absolute;
          top:0;
          left:${toRem(7)};
          z-index:-1;
          @media ${theme.mediaQuery.mobileOnly} {
             z-index:1;
           }
        }
      }
      .m-form-group {
        margin-bottom: 0;
        max-width: ${toRem(40)};
      }
      .input-control {
        max-width: 100%;
        padding-right: ${toRem(3)};
        padding-left: 0;
        text-align: center;
        padding-bottom: 6px;
        caret-color: ${theme.color['light-orange-2']};
        border-bottom:${toRem(2)} solid ${theme.color['dark-gray-13']} !important ;
      }
      .t-label-xs {
        color: ${theme.color['dark-gray-1']};
      }
      height: ${toRem(79)};
      margin-bottom: 0;
    }
    > span {
      margin-bottom: ${toRem(14)};
      display: inline-block;
      font-size: ${theme.fonts['fontS']};
      &:first-child {
        margin-bottom: ${toRem(14)};
      }
    }
    ${StyledRowDiv} {
      height: auto;
      padding-bottom: ${toRem(14)};
    }
  }
  [class^='icon-'] {
    color: ${theme.color['dark-gray-1']};
  }
  ${StyledIncrementDiv} {
    button:not(.btn-disable) {
      border-color: ${theme.color['mine-shaft']};
    }
    > span{
      font-size:${toRem(22)} !important;
    }
    button:focus{
      box-shadow:none !important;
    }
    button:focus:not(:focus-visible) {
      outline: none;
    }
    .btn-disable:focus-visible {
      outline: none;
    }
  }
  button[type='reset'] {
    color: ${theme.color['gray']};
    margin: ${toRem(-8)} 0 ${toRem(32)} auto;
    display: block;
    background: transparent;
    border: none;
    cursor: pointer;
    @media ${theme.mediaQuery.desktop} {
      margin-top: ${toRem(-4)};
    }
  }
  ${StyledPopupDiv} {
    padding-top: 0;
    @media ${theme.mediaQuery.tablet} {
      max-height: ${toRem(480)};
      padding-bottom: ${toRem(0)};
      left: ${toRem(0)};
      width: ${toRem(386)};
    }
    @media ${theme.mediaQuery.largeDesktop} {
      width: ${toRem(402)};
    }
    .flex-input-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: ${toRem(12)};
      .visually-hidden {
        position: absolute;
        overflow: hidden;
        padding: 0;
        border: 0;
        clip: rect(${toRem(1)}, ${toRem(1)}, ${toRem(1)}, ${toRem(1)});
        height: ${toRem(1)};
        width: ${toRem(1)};
      }
    }
    .addBtmMargin {
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        margin-bottom: ${toRem(32)};
      }
    }
  }
  .children-age-heading {
    color: ${theme.color['gray']};
    padding: ${toRem(24)} ${toRem(24)} ${toRem(8)} ${toRem(16)};
    @media ${theme.mediaQuery.tablet} {
      padding: ${toRem(16)} 0 ${toRem(8)};
    }
  }
`}
`;
